export const terms = `
 terms(taxonomy: "interactions", site: $site) {
    __typename
    data {
      ... on Term_Interactions_Interaction {
        title
        legend
        slug
      }
    }
  }
`
